module.exports = __webpack_public_path__ + "media/images/athletes/2136-51eae7161ee9335e6a3b10ff28c777a6.png";